import {
  DataDeclarationVM,
  DataDeclarationIcaro,
} from 'civil-status/view-models/form-declaration-icaro';
import { DateTime } from 'luxon';
import { formatNameIcaro, formatSurnameIcaro } from '../format-surname-name-icaro';
import { formatTime } from '../format-time';

export const transformerDataDeclaration = (
  data: DataDeclarationIcaro
): DataDeclarationVM | undefined => {
  if (!data) {
    return undefined;
  }

  return {
    state: data.stato,
    typeDeclaration: data.tipoAttoDescrizione || '',
    stateDeclaration: data.statoDescrizione || '',
    dateDeclaration: data.dataDichiarazione
      ? DateTime.fromFormat(data.dataDichiarazione, 'yyyyMMdd')
      : null,
    timeDeclaration: data.oraDichiarazione
      ? DateTime.fromFormat(formatTime(data.oraDichiarazione?.toString()), 'HHmm')
      : null,
    dateArrive: data.dataArrivo ? DateTime.fromFormat(data.dataArrivo, 'yyyyMMdd') : null,
    timeArrive: data.oraArrivo
      ? DateTime.fromFormat(formatTime(data.oraArrivo?.toString()), 'HHmm')
      : null,
    protocolHospital: `${data.annoDichiarazione || ''}${
      data.annoDichiarazione && data.protocolloDichiarazione ? '/' : ''
    }${data.protocolloDichiarazione || ''}`,
    hospital: data.svdOspedaleDescrizione || '',
    surnameSanit: formatSurnameIcaro(data.cognomeNomeSanitario),
    nameSanit: formatNameIcaro(data.cognomeNomeSanitario),
    protocol: data.protocolloAttoNascita?.toString() || '',
    dateAttestation: data.dataAttoNascita
      ? DateTime.fromFormat(data.dataAttoNascita, 'yyyyMMdd')
      : null,
    defectAge: data.difettoEta || '',
    operator: data.codiceOperatore || '',
    dateLastOperation: data.dataOperazione
      ? DateTime.fromFormat(data.dataOperazione, 'yyyyMMdd')
      : null,
    counter: data.key?.contatore,
    reasonRefusal: data.motivoRifiuto || '',
  };
};
